module.exports = __webpack_public_path__ + "img/model-meg.7b4858ae.gif";